(function ($) {

    var drag = {
        elem: null,
        x: 0,
        y: 0,
        scrollPos: 0,
        state: false
    };
    var delta = {
        x: 0,
        y: 0
    };

    $(document).ready(function () {
        if($(window).width()>=992) {
            skrollr.init({
                smoothScrolling: true,
                mobileDeceleration: 1,
                beforerender: function (data) {
                   // $('.home__result').text(data.curTop);
                }
            });
        }
        drag.scrollPos = $(document).scrollTop();

        //alert($(window).height() + " - " + $(window).width())

    });

    $(window).on('resize',function(){
        if($(window).width()<=992){
            skrollr.init().destroy();
            /*
                $('window').scrollTop(0);
                setTimeout(function (){
                    var container = $('[animationInserted]');
                    var element = $('[animateMe]');
                    container.find(element).each(function() {
                        console.log(this);
                        var animationMethod = $(this).data('animationmethod');
                        $(this).addClass(animationMethod + " animated");
                    });
                },500);
            */
        }else{
            skrollr.init({
                smoothScrolling: true,
                mobileDeceleration: 1,
                beforerender: function (data) {
                    //$('.home__result').text(data.curTop);
                }
            });
        }
    });

    $(document).on('mousedown touchstart',function(e) {
        //console.log(e.target);
        if($(e.target).attr('id')=="query02"){$('#query02').focus();}
        if (!drag.state) {
            drag.elem = this;
            drag.x = e.pageX;
            drag.y = e.pageY;
            drag.state = true;
        }
        if($(window).width()>992) {
            return false;
        }
    });

    var a =0;

    $(document).on('mousemove',function(e) {
        if (drag.state) {
            delta.x = e.pageX - drag.x;
            delta.y = e.pageY - drag.y;
            drag.x = e.pageX;
            drag.y = e.pageY;
            var scrolled = $(document).scrollTop();
            /*
             $('.result').html(
                 '<table>'
                 + '<tr><td width="250" >Scrolled: </td><td width="70">' 			+ drag.scrollPos
                 + '</td></tr><tr><td>X position: </td><td>' 			+ e.pageX
                 + '</td></tr><tr><td>Delta X position: </td><td>' 	+ delta.x
                 + '</td></tr><tr><td>Amount to scroll: </td><td>' 	+ amountToScroll
                 + '</td></tr><tr><td>A: </td><td>' 					+ a
                 + '</td></tr><tr><td>Current scrolled: </td><td>' 	+ scrolled
                 + '</td></tr><tr></tr></table>'
             );
             */
            if(delta.x>0){
                $(window).scrollTop(scrolled+10);
                //$('.home__result').text(data.curTop);
            }else{
                $(window).scrollTop(scrolled-10);
            }
        }
    });


    $(document).on('mouseup',function() {
        //alert(1);
        if (drag.state) {
            drag.state = false;
            drag.scrollPos = drag.x;
        }
    });

    // $(document).on('touchmove',function(e) {
    //     //$('.home__result').text(e.type);
    //     //console.log(e.touches[0].pageX);
    // });
    $(window).on('resize',function() {
        //$(window).scrollTop(6200);
    });

})(jQuery);

